import { render, staticRenderFns } from "./CustomerHeatMap.vue?vue&type=template&id=884f2d1e&"
import script from "./CustomerHeatMap.vue?vue&type=script&lang=js&"
export * from "./CustomerHeatMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports